const { itemFetcherToArrayGetter, genericGetter } = require("./utilities")
const { gql } = require("@apollo/client")

const DataLoader = require("dataloader")

function batchPropGetter(obj) {
  return async function (keys) {
    let floatKeys = []
    let stringKeys = []
    let fileKeys = []
    let booleanKeys = []
    let floatSeriesKeys = []
    let categorySeriesKeys = []
    let genericKeys = []

    keys.forEach((key) => {
      if (
        [
          "min",
          "max",
          "allowedValues",
          "unitOfMeasurement",
          "permission",
          "precision",
          "value",
        ].includes(key)
      )
        if (key === "value") floatKeys.push("floatValue: value")
        else if (key === "allowedValues")
          floatKeys.push("floatAllowedValues: allowedValues")
        else floatKeys.push(key)

      if (
        ["allowedValues", "permission", "maxCharacters", "value"].includes(key)
      )
        if (key === "value") stringKeys.push("stringValue: value")
        else if (key === "allowedValues")
          stringKeys.push("stringAllowedValues: allowedValues")
        else stringKeys.push(key)

      if (["mimeType", "fileName", "permission", "size"].includes(key))
        if (key === "value") fileKeys.push("fileValue: value")
        else if (key === "allowedValues")
          fileKeys.push("fileAllowedValues: allowedValues")
        else fileKeys.push(key)

      if (key === "value")
        booleanKeys.push("booleanAllowedValues: allowedValues")

      if (
        [
          "min",
          "max",
          "unitOfMeasurement",
          "permission",
          "precision",
          "nodeCount",
          "lastNode",
        ].includes(key)
      )
        floatSeriesKeys.push(key)

      if (["allowedValues", "permission", "nodeCount"].includes(key))
        categorySeriesKeys.push(key)

      if (
        ![
          "allowedValues",
          "permission",
          "maxCharacters",
          "min",
          "max",
          "unitOfMeasurement",
          "precision",
          "value",
        ].includes(key)
      )
        genericKeys.push(key)
    })

    const response = await obj.client.query({
      query: gql`
            {
                variable(id: "${obj.id}"){
                    id
                    ${genericKeys.join("\n")}
                    ${
                      floatKeys[0]
                        ? "... on FloatVariable {\n" +
                          floatKeys.join("\n") +
                          "\n}"
                        : ""
                    }
                      ${
                        stringKeys[0]
                          ? "... on StringVariable {\n" +
                            stringKeys.join("\n") +
                            "\n}"
                          : ""
                      }
                                            ${
                                              fileKeys[0]
                                                ? "... on FileVariable {\n" +
                                                  fileKeys.join("\n") +
                                                  "\n}"
                                                : ""
                                            }
                      ${
                        floatSeriesKeys[0]
                          ? "... on FloatSeriesVariable {\n" +
                            floatSeriesKeys.join("\n") +
                            "\n}"
                          : ""
                      }
                      ${
                        categorySeriesKeys[0]
                          ? "... on CategorySeriesVariable {\n" +
                            categorySeriesKeys.join("\n") +
                            "\n}"
                          : ""
                      }
                      ${
                        booleanKeys[0]
                          ? "... on BooleanVariable {\n" +
                            booleanKeys.join("\n") +
                            "\n}"
                          : ""
                      }
                }
            }
        `,
    })

    const fetchedValues = keys.map((key) => response.data.variable[key])

    return fetchedValues
  }
}

class Variable {
  constructor(client, id) {
    this.client = client
    this.id = id
    this.propLoader = new DataLoader(batchPropGetter(this))
  }

  static fields() {
    return [
      "id",
      "createdAt",
      "updatedAt",
      "thing",
      "permission",
      "developerOnly",
      "hidden",
      "myRole",
      "value",
      "maxCharacters",
      "index",
      "name",
      "allowedValues",
    ]
  }

  get createdAt() {
    return this.propLoader.load("createdAt")
  }

  get updatedAt() {
    return this.propLoader.load("updatedAt")
  }

  get permission() {
    return this.propLoader.load("permission")
  }

  get developerOnly() {
    return this.propLoader.load("developerOnly")
  }

  get hidden() {
    return this.propLoader.load("hidden")
  }

  get myRole() {
    return this.propLoader.load("myRole")
  }

  get value() {
    return this.propLoader.load("value")
  }

  get maxCharacters() {
    return this.propLoader.load("maxCharacters")
  }

  get index() {
    return this.propLoader.load("index")
  }

  get name() {
    return this.propLoader.load("name")
  }

  get allowedValues() {
    return this.propLoader.load("allowedValues")
  }

  get min() {
    return this.propLoader.load("min")
  }

  get max() {
    return this.propLoader.load("max")
  }

  get permission() {
    return this.propLoader.load("permission")
  }

  get maxCharacters() {
    return this.propLoader.load("maxCharacters")
  }

  get unitOfMeasurement() {
    return this.propLoader.load("unitOfMeasurement")
  }

  get precision() {
    return this.propLoader.load("precision")
  }

  get value() {
    return this.propLoader.load("value")
  }
}

const getVariable = (thingId, sortBy, sortDirection, filter) =>
  genericGetter(
    async (index) =>
      gql(`
{
    thing(id:"${await thingId}") {
        id
        variables(offset:${index},limit:1, ${
        sortBy ? "sortBy: " + sortBy : ""
      }, ${sortDirection ? "sortDirection: " + sortDirection : ""}, ${
        filter
          ? "filter: " +
            JSON.stringify(filter).replace(/\"([^(\")"]+)\":/g, "$1:")
          : ""
      }){
            id
        }
    }
}
`),
    "thing.variables",
    Variable
  )

module.exports = { Variable, getVariable }
